import React from 'react';
import Header from '../../component/global/Header';
import SidebarAdmin from '../../component/global/admin/SidebarAdmin';
import TbsubMenu from '../../component/global/admin/Table/TbSubMenu';
import HeaderAdmin from '../../component/global/HeaderAdmin';

export default function SubMenuScreen() {
 return (
  <>
   <HeaderAdmin />
   <div className='page-wrapper'>
    <div className='container-fluid'>
     <TbsubMenu />
    </div>
   </div>
  </>
 )
}